require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./enseignants-prims-2016-2-0-2-1.json") })
        }
      }, "path---enseignants-prims-2016-2-0-2-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---enseignants-prims-2016-2-0-2-1!./.cache/json/enseignants-prims-2016-2-0-2-1.json
// module id = 412
// module chunks = 231608221292675